import { render, staticRenderFns } from "./changeCompetitionStatusModal.vue?vue&type=template&id=5331b0a4&scoped=true&lang=html&"
import script from "./changeCompetitionStatusModal.vue?vue&type=script&lang=js&"
export * from "./changeCompetitionStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./changeCompetitionStatusModal.vue?vue&type=style&index=0&id=5331b0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331b0a4",
  null
  
)

export default component.exports